import React, { useEffect, useState } from 'react';
import { saveRecentDashboard } from '../utils/recentDashboards';
import {
  getCrewActivities,
  subscribeCrewActivities,
} from '../utils/crewTimesheetActivitiesCache';

const toRowData = (row) =>
  row
    ? {
        scopeId: row.scopeId,
        scope: row.scope || 'Unnamed Scope',
        originalData: row,
      }
    : null;

const toActivityOption = (row) => ({
  scopeId: row?.scopeId,
  scope: row?.scope || 'Unnamed Scope',
  originalData: row,
});

function bumpRecent(dashboard) {
  saveRecentDashboard({
    projectId: dashboard.projectId,
    projectName: dashboard.projectName,
    opportunityNo: dashboard.opportunityNo,
    id_project: dashboard.opportunityId,
    Id: dashboard.opportunityId,
    department: dashboard.department,
  });
  window.dispatchEvent(new Event('recentDashboardsUpdated'));
}

export function startCrewTimesheetFromRecent(dashboard, row, allRows, onFlowStarted) {
  bumpRecent(dashboard);
  window.dispatchEvent(
    new CustomEvent('openCrewTimesheet', {
      detail: {
        projectNo: dashboard?.projectId || '',
        projectId: dashboard?.projectId || '',
        projectName: dashboard?.projectName || '',
        opportunityId: dashboard?.opportunityId || '',
        opportunityNo: dashboard?.opportunityNo || '',
        department: dashboard?.department || '',
        rowData: toRowData(row),
        projectActivities: (allRows || []).map(toActivityOption),
      },
    })
  );
  onFlowStarted?.();
}

export function RecentDashboardActivityLinks({ dashboard, onFlowStarted }) {
  const [, setTick] = useState(0);

  useEffect(() => subscribeCrewActivities(() => setTick((n) => n + 1)), []);

  const entry = getCrewActivities(dashboard?.projectId);
  const rows = entry?.rows || [];

  if (rows.length === 0) {
    if (entry?.status !== 'loading') return null;
    return (
      <div className="recent-dashboards-activities recent-dashboards-activities--loading" aria-live="polite">
        Loading activities…
      </div>
    );
  }

  return (
    <div className="recent-dashboards-activities" role="group" aria-label="Activities">
      {rows.map((row, index) => {
        const label = String(row.scope || 'Unnamed Scope').replace(/\s+/g, ' ').trim();
        return (
          <button
            key={`${row.scopeId || label}-${index}`}
            type="button"
            className="recent-dashboards-activity-link"
            title={`Open Crew Timesheet — ${label}`}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              startCrewTimesheetFromRecent(dashboard, row, rows, onFlowStarted);
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
